import { gql } from '@apollo/client'

export const GET_CUSTOM_FIELDS = gql`
  query GetCustomFields($status: CustomFieldStatus, $pageInfo: PageInfoInput) {
    customFields(status: $status, pageInfo: $pageInfo) {
      items {
        customFieldId
        companyId
        key
        label
        fieldType
        isRequired
        requiredForStages
        isSearchable
        status
        sortOrder
        createdAt
        updatedAt
        options {
          optionId
          label
          value
          sortOrder
        }
      }
      totalCount
      pageInfo {
        limit
        offset
      }
    }
  }
`

export const GET_CUSTOM_FIELD = gql`
  query GetCustomField($customFieldId: String!) {
    customField(customFieldId: $customFieldId) {
      customFieldId
      companyId
      key
      label
      fieldType
      isRequired
      requiredForStages
      isSearchable
      status
      createdAt
      updatedAt
      options {
        optionId
        label
        value
        sortOrder
      }
    }
  }
`

export const CREATE_CUSTOM_FIELD = gql`
  mutation CreateCustomField($input: CreateCustomFieldInput!) {
    createCustomField(input: $input) {
      customFieldId
      companyId
      key
      label
      fieldType
      isRequired
      isSearchable
      status
      createdAt
      updatedAt
      options {
        optionId
        label
        value
        sortOrder
      }
    }
  }
`

export const UPDATE_CUSTOM_FIELD = gql`
  mutation UpdateCustomField(
    $customFieldId: String!
    $input: UpdateCustomFieldInput!
  ) {
    updateCustomField(customFieldId: $customFieldId, input: $input) {
      customFieldId
      companyId
      key
      label
      fieldType
      isRequired
      isSearchable
      status
      createdAt
      updatedAt
      options {
        optionId
        label
        value
        sortOrder
      }
    }
  }
`

export const ARCHIVE_CUSTOM_FIELD = gql`
  mutation ArchiveCustomField($customFieldId: String!) {
    archiveCustomField(customFieldId: $customFieldId) {
      customFieldId
      status
    }
  }
`

export const REORDER_CUSTOM_FIELDS = gql`
  mutation ReorderCustomFields($fields: [ReorderCustomFieldsInput!]!) {
    reorderCustomFields(fields: $fields) {
      customFieldId
      key
      label
      fieldType
      isRequired
      isSearchable
      status
      sortOrder
      createdAt
      updatedAt
      options {
        optionId
        label
        value
        sortOrder
      }
    }
  }
`

export const GET_APPLICANT_CUSTOM_FIELD_VALUES = gql`
  query GetApplicantCustomFieldValues(
    $applicantId: String!
    $pageInfo: PageInfoInput
  ) {
    applicantCustomFieldValues(applicantId: $applicantId, pageInfo: $pageInfo) {
      items {
        applicantCustomFieldValueId
        applicantId
        customFieldId
        stringValue
        booleanValue
        dateValue
        selectValues
        createdAt
        updatedAt
        customField {
          customFieldId
          key
          label
          fieldType
          isRequired
          isSearchable
          status
          sortOrder
          options {
            optionId
            label
            value
            sortOrder
          }
        }
      }
      pageInfo {
        limit
        offset
      }
      totalCount
    }
  }
`

export const SET_APPLICANT_CUSTOM_FIELD_VALUE = gql`
  mutation SetApplicantCustomFieldValue($input: SetApplicantCustomFieldValueInput!) {
    setApplicantCustomFieldValue(input: $input) {
      applicantCustomFieldValueId
      customFieldId
      stringValue
      booleanValue
      dateValue
      selectValues
      updatedAt
    }
  }
`

export const DELETE_APPLICANT_CUSTOM_FIELD_VALUE = gql`
  mutation DeleteApplicantCustomFieldValue($applicantCustomFieldValueId: String!) {
    deleteApplicantCustomFieldValue(applicantCustomFieldValueId: $applicantCustomFieldValueId) {
      applicantCustomFieldValueId
    }
  }
`

export const GET_CUSTOM_FIELD_AUDIT_TRAIL = gql`
  query GetCustomFieldAuditTrail($customFieldId: String!) {
    customFieldAuditTrail(customFieldId: $customFieldId) {
      auditTrailId
      createdAt
      changeType
      notes
      employeeId
      prevOptions
      newOptions
      prevLabel
      newLabel
      prevIsRequired
      newIsRequired
      prevRequiredForStages
      newRequiredForStages
      prevIsSearchable
      newIsSearchable
      prevStatus
      newStatus
      employee {
        employeeId
        firstName
        lastName
      }
    }
  }
`

export const GET_APPLICANT_CUSTOM_FIELD_VALUE_AUDIT_TRAIL = gql`
  query GetApplicantCustomFieldValueAuditTrail(
    $applicantCustomFieldValueId: String!
  ) {
    applicantCustomFieldValueAuditTrail(
      applicantCustomFieldValueId: $applicantCustomFieldValueId
    ) {
      auditTrailId
      createdAt
      changeType
      notes
      employeeId
      fieldKey
      fieldLabel
      fieldType
      prevStringValue
      prevBooleanValue
      prevDateValue
      prevSelectValues
      newStringValue
      newBooleanValue
      newDateValue
      newSelectValues
      employee {
        employeeId
        firstName
        lastName
      }
    }
  }
`
